/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Linkable } from '@/components/blocks/Linkable';
import { sidebarPaperSX } from '@/components/blocks/SideBar/styles/paper';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Accordion, AccordionSummary, Paper, SxProps, Typography } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import { sidebarAccordionSummarySX } from '@/components/blocks/SideBar/styles/accordionSummary';
import { combineSX } from '@/utils/combineSX';
type Props = {
	title: string;
	href?: string;
	scrollable?: boolean;
	isMobile: boolean;
	toggleOpen: () => void;
	sidebarAccordionSummarySXP?:SxProps;
	showAccordionTitle?:boolean;
	titleH2Component?:string;
};

export const SidebarContent: FC<PropsWithChildren<Props>> = ({
	title,
	showAccordionTitle = true,
	href,
	isMobile,
	toggleOpen,
	scrollable = false,
	children,
	sidebarAccordionSummarySXP,
}) => (
	<Paper elevation={0} sx={sidebarPaperSX({ isMobile, scrollable })}>
		<Accordion expanded={true} square={true} id="sidebar-content" data-testid="sidebar-content">
      {showAccordionTitle ?
        <AccordionSummary
				sx={combineSX([sidebarAccordionSummarySX({isMobile}),sidebarAccordionSummarySXP??{}])}
				expandIcon={isMobile ? <ExpandLessIcon /> : null}
				onClick={toggleOpen}
				aria-controls="facets-content"
				id="facets-header"
				data-testid="facets-header"
			>
				{href ? (
					<Linkable
						id={`account-sidebar-${title.toLowerCase()}`}
						data-testid={`account-sidebar-${title.toLowerCase()}`}
						href={href}
					>					
						<Typography variant = "body2">{title}</Typography>
					</Linkable>
				) : (
					 <Typography variant = "body2">{title}</Typography> 
				)}
			</AccordionSummary>
        :null}
			{children}
		</Accordion>
	</Paper>
);
